import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Container = styled.div`
  padding: 1rem 0 2rem;
  @media (min-width: ${breakpoints.lg}) {
    padding: 1rem 0;
  }
`;

export const SelectWrapper = styled.div``;

export const Select = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DeliveryList = styled.div`
  flex: 10;
  padding-right: 0.5rem;
`;

export const FlexRow = styled.div`
  align-items: flex-start;
  justify-content: space-between;
  color: ${theme.color.text.secondary};
  display: flex;
  flex-wrap: wrap;
`;

export const DeliveryInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-basis: 100%;
  align-items: center;
  cursor: pointer;
`;

export const TopDeliveryInfo = styled(DeliveryInfo)`
  flex-basis: 100%;

  &:last-child {
    margin-bottom: 0;
  }

  margin-bottom: 1.25rem;
`;

export const DeliveryInfoWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export interface IDeliveryTextColorProps {
  isInactive: boolean;
}

export const Name = styled.div<IDeliveryTextColorProps>`
  padding-right: 0.3125rem;
  min-width: 12.5rem;
  flex-basis: 100%;
  line-height: 1.2rem;
  color: ${(props) =>
    props.isInactive ? theme.color.text.disabled : theme.color.text.primary};

  ${theme.typography.labelRegular}

  margin-bottom: 4px;

  @media (min-width: ${breakpoints.sm}) {
    flex-basis: auto;
    line-height: 1.3rem;
  }

  @media (min-width: ${breakpoints.md}) {
    flex-basis: 100%;
    line-height: 1.2rem;
  }

  @media (min-width: ${breakpoints.lg}) {
    flex-basis: auto;
    line-height: 1.3rem;
  }
`;

export const DeliveryDate = styled.div<IDeliveryTextColorProps>`
  line-height: 1.2rem;
  color: ${(props) =>
    props.isInactive ? theme.color.text.disabled : theme.color.text.primary};

  ${theme.typography.labelRegular400}

  @media (min-width: ${breakpoints.sm}) {
    line-height: 1.3rem;
  }
`;

export const TimeText = styled.span`
  color: ${theme.color.text.positive};
  font-weight: 500;
`;
